import React from 'react'
import styled from 'styled-components/macro'
import PropTypes from 'prop-types'
import { Text } from 'components/atoms'

const FieldArrayDndHeader = ({ columnProps = [] }) => (
  <Header>
    <HeaderColumn small />
    {
      columnProps.map(({
        Header,
        accessor,
      }) => (
        <Header key={accessor} />
      ))
    }
    <HeaderColumn small />
  </Header>
)

FieldArrayDndHeader.propTypes = {
  columnProps: PropTypes.arrayOf(
    PropTypes.shape({
      Header: PropTypes.node,
      accessor: PropTypes.string,
      Cell: PropTypes.node,
      value: PropTypes.node
    })
  ),
}

FieldArrayDndHeader.defaultProps = {
  columnProps: [],
}


const Header = styled.div`
  border-bottom: 2px solid ${props => props.theme.colors.borderLighter};
  margin-bottom: 8px;
  display: flex;
  border-radius: 4px;
  align-items: center;
  font-size: ${props => props.theme.sizes.s};
`;


export const HeaderColumn = styled.div`
  align-items: ${props => (props.center ? 'center' : 'flex-start')};
  padding-top: ${props => props.theme.spacing.m};
  padding-bottom: ${props => props.theme.spacing.m};
  justify-content: center;
  flex-grow: ${props => (props.small ? 0.2 : 1)};
  max-width: ${props => (props.small && '80px': "none")};
  overflow-x: visible;
  flex-shrink: 0;
  flex-basis: 24px;
  margin-right: ${props => props.theme.spacing.xs};
  ${Text} {
    font-weight: ${props => props.theme.weight.xbase};
  }
`;

export default FieldArrayDndHeader
